import type { CallAgent } from '@api/models';
import { defineStore } from 'pinia';

import { stuut } from '@/api';

interface State {
  callAgent: CallAgent | null;
  isLoading: boolean;
}

export const useCallAgent = defineStore('callAgent', {
  actions: {
    async fetchCallAgent() {
      try {
        this.$patch({ isLoading: true });
        const callAgent = await stuut.callAgents.retrieve();
        this.$patch({ callAgent });
        return callAgent;
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.$patch({ isLoading: false });
      }
    },
  },
  state: (): State => ({
    callAgent: null,
    isLoading: false,
  }),
});

export default useCallAgent;
